import $ from 'jquery';
import 'jquery-match-height';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

new Swiper('.home-blog-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    navigation: {
        nextEl: '.home-blog-slider-next',
        prevEl: '.home-blog-slider-prev',
    },
    pagination: {
        el: '.home-blog-pagination',
        type: 'bullets',
    },
    breakpoints: {
        1366: {
            pagination: false,
        },
        1850: {
            slidesPerView: 2,
        },
        2050: {
            slidesPerView: 3,
        },
        2350: {
            slidesPerView: 4,
        },
    },
    modules: [
        Navigation, Pagination
    ]
});

$('.home-blog-slider .feed-post-wrapper').matchHeight();

new Swiper('.home-approval-slider', {
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
        nextEl: '.home-approval-slider-next',
        prevEl: '.home-approval-slider-prev',
    },
    breakpoints: {
        992: {
            spaceBetween: 20,
            slidesPerView: 3,
        },
    },
});

$('.header-search-input').on('focusin', function () {
    let width = $(window).width();
    $(this).parent().find('button').removeClass('locked');
    $(document).width = width;
});

$('.header-search-input').on('focusout', function () {
    setTimeout(function () {
        $(this).parent().find('button').addClass('locked');
    }, 200);
});
